import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppState } from '@app/app.service';
import { CUSTOMER_CARE_NUMBER } from '@env/environment';
import { ToastrHelperService } from '@services/toast-helper.service';
import { UserAccountServiceNoSync } from '@ztarmobile/zwp-service-backend';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { takeWhile } from 'rxjs';
import { ACCOUNT_ROUTE_URLS, ROUTE_URLS, SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';
import { ModalHelper } from 'src/services/modal-helper.service';

@Component({
  selector: 'app-fifth-generation-page',
  templateUrl: './fifth-generation-page.component.html',
  styleUrls: ['./fifth-generation-page.component.scss']
})

export class IosFifthGenerationPageComponent implements OnInit, OnDestroy {
  @Output() backToMain: EventEmitter<boolean> = new EventEmitter();

  public CUSTOMER_CARE_NUMBER = CUSTOMER_CARE_NUMBER;
  public IosVersionsForm: FormGroup;
  public isVersionSubmitted = false;
  public isManuallyClicked = false;
  public mdn: string;
  public isLoggedIn = false;
  public innerWidth;

  private alive = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalHelper: ModalHelper,
    private formBuilder: FormBuilder,
    private toastHelper: ToastrHelperService,
    private appState: AppState,
    private simpleAuthService: SimpleAuthService,
    private userAccountService: UserAccountServiceNoSync) {

    this.IosVersionsForm = formBuilder.group({
      option: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.innerWidth = window.screen.width;
    this.route.params.pipe(takeWhile(() => this.alive)).subscribe((params: Params) => {
      if (!!params) {
        if (!!params[SUPPORT_ROUTE_URLS.PARAMS.MDN]) {
          this.mdn = params[SUPPORT_ROUTE_URLS.PARAMS.MDN];
        }
      }
    });
    this.simpleAuthService.userState.subscribe((authState) => {
      this.isLoggedIn = !!authState && !authState.isAnonymous;
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  public back(): void {
    if (!!this.isVersionSubmitted && !!this.isManuallyClicked) {
      this.isManuallyClicked = false;
    } else if (!!this.isVersionSubmitted) {
      this.isVersionSubmitted = false;
    } else {
      this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_IPHONE}`]);
    }
  }

  public submitVersion(): void {
    this.IosVersionsForm.markAllAsTouched();
    if (!!this.IosVersionsForm.valid) {
      this.isVersionSubmitted = true;
    }
  }

  public goToAccountSummary(): void {
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
  }

  public add5GManually(): void {
    this.isManuallyClicked = true;
    window.scroll(0, 500);
  }

  public done(): void {
    if (!!this.isLoggedIn) {
      this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
    } else {
      this.router.navigate([`${ROUTE_URLS.HOME}`]);
    }
  }

  public enable5G(): void {
    this.appState.loading = true;
    this.userAccountService.enable5G(this.mdn).then((result) => {
      if (!!result) {
        this.appState.loading = false;
        this.showSuccessModal();
        let link = document.createElement('a');
        link.setAttribute('type', 'hidden');
        link.href = 'assets/ereseller.mobileconfig';
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    }, (error) => {
      this.appState.loading = false;
      this.toastHelper.showAlert(error.error.message);
    });
  }

  public showLTEsettingPopUp(): void {
    this.modalHelper.ShowIosDataSetupModalComponent('5G')
      .afterClosed().subscribe((result) => {
        if (result) {
          // nothing to do in first step for back button
        }
      }, (error) => {
        console.error('error', error);
      });
  }

  public showIos17PopUp(): void {
    this.modalHelper.showIphone5GIos17InstructionsModal();
  }

  private showSuccessModal(): void {
    this.modalHelper.successModal('5G and file download were successfully processed!', 'Done', 'success-modal').afterClosed().subscribe((res) => {
      if (!!res) {
        this.userAccountService.selectedAccount.pipe(takeWhile(() => this.alive)).subscribe((account) => {
          if (!!account) {
            const userAccount = account;
            userAccount.tech5gEnabled = true;
          }
          this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
        });
      }
    });
  }

  @HostListener("window:keydown.esc", ["$event"])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
      if (document.querySelector('body div.success-modal')) {
        this.showSuccessModal();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.screen.width;
  }
}
